/*
 * pww-atc.js — shared "Add to Cart" + quick-view behaviour for product cards.
 *
 * Drives the [data-pww-atc] buttons used by:
 *   - the "Pairs well with" carousel cards (.pww-card)
 *   - the theme's standard product cards (.cc-product-block), whose hover
 *     overlay button is an Add to Cart button.
 *
 * Single-variant products      → AJAX add straight to cart.
 * Multi-variant products        → small variant picker popup, then AJAX add.
 * On any failure                → fall back to opening the quick-view modal.
 *
 * Loaded once, site-wide, from layout/theme.liquid. The window guard keeps it
 * idempotent if it is ever included more than once.
 */
(function () {
  if (window._pwwAtcReady) return;
  window._pwwAtcReady = true;

  var CARD_SELECTOR = '.pww-card, .cc-product-block';

  function openQuickview(url) {
    if (!url) return;
    var tmp = document.createElement('a');
    tmp.href = url;
    tmp.setAttribute('data-cc-quick-buy', '');
    document.body.appendChild(tmp);
    if (typeof jQuery !== 'undefined') { jQuery(tmp).trigger('click'); } else { tmp.click(); }
    document.body.removeChild(tmp);
  }

  // Open the slide-in cart drawer after a successful add (same as the
  // "Pairs well with" block and the theme's own add-to-cart forms). Falls
  // back to the cart:item-added event the drawer also listens for; if no
  // drawer is enabled, nothing happens beyond the icon refresh.
  function openCartDrawer() {
    if (window.PbCartDrawer && typeof window.PbCartDrawer.refreshAndOpen === 'function') {
      window.PbCartDrawer.refreshAndOpen();
    } else {
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, cancelable: false }));
    }
  }

  function refreshCartIcon() {
    if (typeof jQuery === 'undefined' || typeof theme === 'undefined' || !theme.routes) return;
    jQuery.get(theme.routes.cart_url, function (data) {
      var sel = '#site-control .cart:not(.nav-search)';
      var fresh = jQuery(jQuery.parseHTML('<div>' + data + '</div>')).find(sel);
      jQuery(sel).each(function (i) {
        jQuery(fresh[i]).find('[data-cc-animate]').removeAttr('data-cc-animate');
        jQuery(this).replaceWith(fresh[i]);
      });
    });
  }

  function doAddToCart(vid, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw r;
      return r.json();
    }).then(onSuccess).catch(onError);
  }

  function showVariantPicker(btn) {
    var card = btn.closest(CARD_SELECTOR);
    var dataEl = card ? card.querySelector('.pww-variants-data') : null;
    if (!dataEl) { openQuickview(btn.dataset.productUrl); return; }

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { openQuickview(btn.dataset.productUrl); return; }

    document.querySelectorAll('.pww-vpicker').forEach(function (el) { el.remove(); });

    var html = '<div class="pww-vpicker__head">' +
      '<span class="pww-vpicker__label">Select option</span>' +
      '<button class="pww-vpicker__close" aria-label="Close">&times;</button>' +
      '</div>';
    variants.forEach(function (v) {
      html += '<button class="pww-vpicker__opt' + (v.available ? '' : ' pww-vpicker__opt--na') + '"' +
        ' data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="pww-vpicker__opt-name">' + v.title + '</span>' +
        '<span class="pww-vpicker__opt-price" data-raw-price="' + (v.price_raw || '') + '">' + v.price + '</span>' +
        '</button>';
    });

    var picker = document.createElement('div');
    picker.className = 'pww-vpicker';
    picker.innerHTML = html;
    document.body.appendChild(picker);

    // Position above the button (or below if not enough room)
    var rect = btn.getBoundingClientRect();
    var pickerW = Math.max(rect.width, 200);
    picker.style.width = pickerW + 'px';
    picker.style.left = Math.min(rect.left, window.innerWidth - pickerW - 8) + 'px';
    var pickerH = picker.offsetHeight;
    if (rect.top >= pickerH + 16) {
      picker.style.top = (rect.top - pickerH - 8) + 'px';
    } else {
      picker.style.top = (rect.bottom + 8) + 'px';
    }

    picker.querySelector('.pww-vpicker__close').addEventListener('click', function () { picker.remove(); });

    setTimeout(function () {
      function onOutside(e) {
        if (!picker.contains(e.target) && e.target !== btn) {
          picker.remove();
          document.removeEventListener('click', onOutside);
        }
      }
      document.addEventListener('click', onOutside);
    }, 0);

    picker.querySelectorAll('.pww-vpicker__opt:not([disabled])').forEach(function (optBtn) {
      optBtn.addEventListener('click', function () {
        optBtn.disabled = true;
        optBtn.style.opacity = '0.5';
        doAddToCart(optBtn.dataset.vid, function () {
          picker.remove();
          btn.classList.add('pww-card__atc--added');
          btn.textContent = btn.dataset.addedText;
          document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
          refreshCartIcon();
          openCartDrawer();
          setTimeout(function () {
            btn.classList.remove('pww-card__atc--added');
            btn.textContent = btn.dataset.addText;
          }, 2500);
        }, function () {
          picker.remove();
          openQuickview(btn.dataset.productUrl);
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pww-atc]');
    if (!btn || btn.disabled) return;

    var isSingle   = btn.dataset.singleVariant === 'true';
    var variantId  = btn.dataset.variantId;
    var productUrl = btn.dataset.productUrl;
    var addText    = btn.dataset.addText;
    var addedText  = btn.dataset.addedText;

    if (!isSingle) {
      showVariantPicker(btn);
      return;
    }

    btn.disabled = true;
    doAddToCart(variantId, function () {
      btn.classList.add('pww-card__atc--added');
      btn.textContent = addedText;
      document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
      refreshCartIcon();
      openCartDrawer();
      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('pww-card__atc--added');
        btn.textContent = addText;
      }, 2500);
    }, function () {
      btn.disabled = false;
      openQuickview(productUrl);
    });
  });
}());
